import { ref, computed } from "vue";
import { fabric } from "fabric";
import { store } from "@/store";

import { canvas } from "@/canvas-api/Canvas";
import { centerAndSizeScrollers } from "@/canvas-api/ViewPort";

export const zoomValue = ref(250);
export const isZooming = ref(false);

export const setZoomValue = (val: number) => {
  zoomValue.value = val;
};

export const setIsZooming = (val: boolean) => {
  isZooming.value = val;
};

const isRotated = computed<boolean>(() =>
  store.getters.canvasOrientation === "rotated" ? true : false
);
const labelWidth = computed(() =>
  isRotated.value ? store.getters.labelHeight : store.getters.labelWidth
);
const labelHeight = computed(() =>
  isRotated.value ? store.getters.labelWidth : store.getters.labelHeight
);

export const zoomOnMount = (
  canvas: fabric.Canvas,
  clientWidth: number,
  clientHeight: number,
  offSet: number
): void => {
  const zoomWidthValue = clientWidth / (labelWidth.value + offSet * 2);
  const zoomHeightValue = clientHeight / (labelHeight.value + offSet * 2);

  let initZoomValue = zoomWidthValue < zoomHeightValue ? zoomWidthValue : zoomHeightValue;

  const canvasCenter = canvas.getCenter();
  const point: fabric.Point = new fabric.Point(canvasCenter.left, canvasCenter.top);

  //If not reduced canvas zooms to fit screen, reducing it make for a better fit
  initZoomValue *= 0.65;

  if (initZoomValue > 5) initZoomValue = 5;

  canvas.zoomToPoint(point, initZoomValue);
  setZoomValue(Math.round(initZoomValue * 100));
};

export const mobileZoom = (value: number) => {
  const canvasCenter = canvas.value.getCenter();
  const point: fabric.Point = new fabric.Point(canvasCenter.left, canvasCenter.top);

  if (value > 0) {
    if (canvas.value.getZoom() < 4) {
      const delta = canvas.value.getZoom() + 0.02;
      canvas.value.zoomToPoint(point, delta);
    }
  } else {
    if (canvas.value.getZoom() > 0.2) {
      const delta = canvas.value.getZoom() - 0.02;
      canvas.value.zoomToPoint(point, delta);
    }
  }

  centerAndSizeScrollers();
};
